import { Box, forwardRef } from '@chakra-ui/react';

const AlertTitle = forwardRef<any, 'div'>((props, ref) => {
	return <Box display="inline" lineHeight="base" fontWeight="medium" ref={ref} {...props} />;
});

AlertTitle.displayName = 'AlertTitle';

export { AlertTitle };
